import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap'
import './HotelRoomsOverView.css';
import { Link } from 'react-router-dom';
import { TiTickOutline } from "react-icons/ti";
import { CiLocationOn } from "react-icons/ci";

const HotelRoomsOverView = ({ hotelData }) => {
    const [showModal, setShowModal] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showOverview, setShowOverview] = useState(false);
  const [showAmenities, setShowAmenities] = useState(false);
const [selectedRoom, setSelectedRoom] = useState(null);

const handleShow = (room) => {
    setSelectedRoom(room);
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getPlainText = (description) => {
    if (!description) return null;

  let parsedData = null;

  try {
    parsedData = JSON.parse(description);
  } catch (e) {
    parsedData = null;
  }

  return (
    <ul className="hotel-description">
      {parsedData && typeof parsedData === "object" && !Array.isArray(parsedData) ? (
        Object.entries(parsedData).map(([key, value]) => (
          <li key={key}>
            <b>{key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}</b>
            : {value}
          </li>
        ))
      ) : (
        <li>{description}</li>
      )}
    </ul>
  );
  };

  // const amenitiesHotelList = JSON.parse(hotelData.HotelDetail.ameneties);
  
const amenitiesHotelList = Array.isArray(hotelData.hotel.facilities)
  ? hotelData.hotel.facilities
  : typeof hotelData.hotel.facilities === "string"
    ? hotelData.hotel.facilities.split(",").map(item => item.trim())
    : [];


  const lat = hotelData.hotel.HotelLat;
const lng = hotelData.hotel.HotelLng;
const navigate = useNavigate();

const handleBookNowClick = (hotelId, roomid) => {
  

  localStorage.setItem("hotelId", hotelId);
  
  localStorage.setItem("roomid", roomid);

  navigate("/hotelfinalbooking");
};

const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};


  return (
    <div className='hotel-RoomsOverViewMain'>
      <Container>
       
        <div className={isSticky ? 'hotel-RoomsOverViewMenu sticky' : 'hotel-RoomsOverViewMenu'}>
          <a href="#rooms-section" className='hotel-RoomsOverViewMenuItems'>Rooms</a>

          <a
            href="#overview-section"
            className='hotel-RoomsOverViewMenuItems'
            onClick={(e) => {
              if (window.innerWidth <= 600) {
                e.preventDefault();
                setShowOverview(true);
                setTimeout(() => {
                  document.getElementById('overview-section').scrollIntoView({ behavior: 'smooth' });
                }, 50);
              }
            }}
          >
            Overview
          </a>

          <a
            href="#amenities-section"
            className='hotel-RoomsOverViewMenuItems'
            onClick={(e) => {
              if (window.innerWidth <= 600) {
                e.preventDefault();
                setShowAmenities(true);
                setTimeout(() => {
                  document.getElementById('amenities-section').scrollIntoView({ behavior: 'smooth' });
                }, 50);
              }
            }}
          >
            Amenities
          </a>

          <a href="#location-section" className='hotel-RoomsOverViewMenuItems'>Location</a>
          <a href="#booking-policy-section" className='hotel-RoomsOverViewMenuItems booking-policy-link'>Booking Policy</a>
        </div>

        <div className='hotel-RoomsOverViewMenuFinalBooking'>
          <div className='hotel-RoomsOverViewRoomsBenefits'>
            <div>Room Type</div>
            <div>Benefits</div>
            <div>Per Night Price</div>
          </div>

          <div id='rooms-section'>
            {hotelData.hotel.Rooms?.map((room, index) => 
           room.RoomInfo?.map((roominfo, index1) => (
              <Row className='hotel-finalRoomType-Row' key={index1}>
                <Col className='hotel-finalRoomType-Col'>
                  <div className="hotel-finalRoomType">{roominfo.RoomCategory}</div>
                  <div><img src={roominfo?.Images?.[0]?.url} alt="" className='hotel-finalRoomTypeImg' /></div>
                  <div className='hotel-finalRoomType-Btn'>{roominfo.RoomType}</div>
                </Col>

                <Col className='hotel-finalRoomType-Col'>
                  <div className='hotel-RoomsOnly'>{roominfo.MealBasis}</div>
                  <div className="hotel-RoomsOverViewMain">
                    {/* <div className="hotel-RoomsOnly-Item">
                      <TiTickOutline className="hotel-RoomsOnly-Icons" />
                      <span>{room.Inclusion}</span>
                    </div> */}
                    {roominfo.fcs.map((inclusion, index) => (
                      <div key={index} className="hotel-RoomsOnly-Item">
                        <TiTickOutline className="hotel-RoomsOnly-Icons" />
                        <span>{inclusion.trim()}</span>
                      </div>
                    ))}
                    
                     <Button variant="danger" size="sm" onClick={() => handleShow(room)}>
                      View Policy
                    </Button>
                    
                    {room?.ddt && (
                      <p className="text-success fw-semibold">
                        Free cancellation before {formatDate(room.ddt)}
                      </p>
                    )}
                    
                   {room?.PanRequired === true && (
                      <span className="text-success fw-semibold">
                        PAN Required
                      </span>
                    )}
                    
                    {room?.PassportRequired === true && (
                      <span className="text-success fw-semibold">
                        Passport Required
                      </span>
                    )}
                  </div>
                </Col>

                <Col className='hotel-finalRoomType-Col'>
                  <div className="hoteRoom-UsageCharges">
                  
                    <div className='real-pricing'>₹ {Math.round(room.PublishedFare)}</div>
                   
                    <div className='hotel-taxesFees' style={{ color: "#737373" }}>Base price (Per Night)</div>
                  </div>
                 
                </Col>

                <Col className='hotel-finalRoomType-Col'>
                    <button
                      className="hotel-RoomsOnly-ItemBookNowBtn"
                      onClick={() => handleBookNowClick(hotelData.hotel.id, room.id)}
                    >
                      Book Now
                    </button>
                  </Col>

              </Row>
            ))
            )}
          </div>
        </div>
    

      <div className='hotel-RoomOverView-Description'>
        
          <div
            id="overview-section"
            className='hotel-Rooms-Des'
            style={{ display: window.innerWidth > 600 || showOverview ? 'block' : 'none' }}
          >
            <div className="hotelListingstyling-name hotelListingstylingDetail-name">
              {hotelData.hotel.HotelName}
               <div className="rating-score" style={{ textAlign: 'center', fontSize: '18px' }}>
                      {[...Array(5)].map((_, index) => (
                        <span key={index} style={{ color: index < Number(hotelData.hotel.HotelRating) ? '#FFD700' : '#ccc',}}>★</span>))}
                        </div>
            </div>
            <div className="hotel-Address">
              <CiLocationOn /> <span>{hotelData.hotel.HotelAddress}</span>
            </div>
            <div className='hotel-Rooms-Des-Below'>Hotel Description</div>
            <p style={{ padding: '10px 0px', fontSize: '14px' }}>
             
             {getPlainText(hotelData.hotel.HotelDescription)}
            </p>
          </div>

          <div
            id="amenities-section"
            className='hotel-Rooms-Des hotel-Rooms-BookingAmeni'
            style={{ display: window.innerWidth > 600 || showAmenities ? 'block' : 'none' }}
          >
            <div className='hotel-Rooms-Ameni-Below'>Amenities</div>
            <div className="hotel-amenities-lists">
              {amenitiesHotelList.map((amenity, index) => (
                <div key={index} className="free_amenitiesList">
                  <TiTickOutline className="hotel-RoomsOnly-Icons" />
                  <span>{amenity}</span>
                </div>
              ))}
            </div>
          </div>

          <div id="location-section" className='hotel-Rooms-Des hotel-Rooms-BookingLocation'>
            <div className='hotel-Rooms-Ameni-Below'>Location</div>
            <div>
              <iframe
      src={`https://www.google.com/maps?q=${lat},${lng}&hl=en&z=14&output=embed`}
      width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
            </div>
          </div>

         {/* Modal for showing policies */}
     <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Room Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRoom?.CancellationPolicy?.pd?.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>From</th>
                    <th>To</th>
                    <th>Penalty Amount</th>
                    <th>Penalty %</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedRoom.CancellationPolicy.pd.map((p, i) => (
                    <tr key={i}>
                      <td>{formatDate(p.fdt)}</td>
                      <td>{formatDate(p.tdt)}</td>
                      <td>
                        {p.am === 0 ? "Free Cancellation" : `₹ ${p.am}`}
                      </td>
                      <td>{p.pp ?? "-"}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No cancellation policy available</p>
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> 
        
      </div>
      </Container>
    </div>
  );
};

export default HotelRoomsOverView;
